import { Component } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationRole } from 'src/app/core/models/ApplicationRole';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { AdminService } from '../../admin/admin.service';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-view-query',
  standalone: false,
  templateUrl: './view-query.component.html',
  styleUrl: './view-query.component.less'
})
export class ViewQueryComponent {
  currentUser: User = new User();
  queryCode: number = 0;
  queryModel: QueryModel = new QueryModel();

  queryNewEnum = QueryStatus.New;
  userRFCAdmin = ApplicationRole.RFCAdmin;
  userJVAdvisor = ApplicationRole.JVAdvisor;
  userDeptRepresentative = ApplicationRole.DeptRepresentative;
  userSponsor = ApplicationRole.Sponsor;
  queryStatus: any;

  queryDetails: QueryDetailModel[] = [];
  partnerUserMaster: { item_id: any; item_text: any }[] = [];
  CCSubDepartmentsMaster: { item_id: any; item_text: any }[] = [];
  selectedCCUsers: { item_id: any; item_text: any }[] = [];
  selectedCCSubDepts: { item_id: any; item_text: any }[] = [];
  canExportToPDF = false;

  queryPermission = {
    'canViewQuery': false,
    'canUpdateQuery': false,
    'canAssignToDept': false,
    'canNotifyToPartner': false,
    'canProvideAddtionlComments': false,
    'canProvideQueryAnsToRFCAdmin': false,
    'canUpdateRequestdetails': false,
    'canUpdateCCUser': false,
    'CanUpdateCCDepartments': false
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,

    private userService: UserService,
    private adminService : AdminService,
    private queryService: ClarificationQueryListService) {
    const queryCodeParam = this.route.snapshot.paramMap.get('queryCode');
    this.queryCode = queryCodeParam ? +queryCodeParam : 0;
  }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();  
    if (this.currentUser?.User_Code == null) {
      this.userService.userUpdated.subscribe((updatedUser: User) => {
        this.currentUser = updatedUser;
        this.initialLoading();
      }); 
    }else{
      this.initialLoading();
    }
  }
  initialLoading(){
    this.queryService.getQueryDetail(this.queryCode, this.currentUser.User_Code ?? 0).subscribe({
      next: (response: any) => {
        if (response.isAccessible) {
          this.queryModel = response.output;
          
          this.queryModel.QueryDetail.Department_Code = this.resetToDefaultValue(this.queryModel.QueryDetail.Department_Code);
          this.queryModel.QueryDetail.Sub_Dept_Code = this.resetToDefaultValue(this.queryModel.QueryDetail.Sub_Dept_Code);
          this.queryModel.QueryDetail.Block_Code = this.resetToDefaultValueNumber(this.queryModel.QueryDetail.Block_Code);
          this.queryModel.QueryDetail.Clarification_Cat_Code = this.resetToDefaultValue(this.queryModel.QueryDetail.Clarification_Cat_Code);
          this.queryModel.QueryDetail.Clarification_SubCat_Code = this.resetToDefaultValue(this.queryModel.QueryDetail.Clarification_SubCat_Code);
          this.setQueryPermission();
          this.canExportToPDF = (this.queryModel.CanViewPrevsQueryDtls || this.queryModel.QueryStatusEnum == QueryStatus.Responded);
        } else {
          this.redirectToHome("You are not authorized to view the selected Query Details.");
        }
      },
      error: (error) => {
        this.redirectToHome((error.status == 404) ? "You are not authorized to view the selected Query Details." : "Error occurred while fetching the query details");
      }
    });
  }

  redirectToHome(erroMsg : string)
  {
    //this.toastrService.error(erroMsg, 'Notification');
    //this.router.navigate(['/home']);
    window.location.href = '/';
  }

  resetToDefaultValue(value: any) {
    return (value == undefined) ? '' : value;
  }

   resetToDefaultValueNumber(value: any) {
    return (value == undefined) ? 0 : value;
  }
  setQueryPermission() {
    switch (this.queryModel.QueryStatusEnum) {
      case QueryStatus.New:
      case QueryStatus.ReOpened:
        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.RFCAdmin) !== -1) {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canAssignToDept = true;
          this.queryPermission.canNotifyToPartner = true;
          this.queryPermission.canUpdateRequestdetails = true;
          this.queryPermission.canUpdateCCUser = true;
          this.queryPermission.CanUpdateCCDepartments = true;
        }
        break;
      case QueryStatus.AssignedToDeptRep:
      case QueryStatus.Recycled:
        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.RFCAdmin) !== -1
            || this.currentUser.ApplicationRoles.indexOf(ApplicationRole.Sponsor) !== -1)
        {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canProvideAddtionlComments = true;
          this.queryPermission.canProvideQueryAnsToRFCAdmin = true;
        }
       
        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.JVAdvisor) !== -1) {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canProvideAddtionlComments = true;
        }

        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.DeptRepresentative) !== -1 ) {
          if (
              this.currentUser.Departments?.indexOf(Number(this.queryModel.QueryDetail.Department_Code)) !== -1 
              && this.currentUser.SubDepartments?.indexOf(Number(this.queryModel.QueryDetail.Sub_Dept_Code)) !== -1 
              ) {
            this.queryPermission.canViewQuery = true;
            this.queryPermission.canUpdateQuery = true;
            this.queryPermission.canProvideQueryAnsToRFCAdmin = true;
          }
        }
        break;
      case QueryStatus.QueryAnsweredByDeptRep:
      case QueryStatus.QueryAnsweredBySponsor:
        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.RFCAdmin) !== -1) {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canProvideAddtionlComments = true;
          this.queryPermission.canNotifyToPartner = true;
          this.queryPermission.canUpdateCCUser = true;
          this.queryPermission.CanUpdateCCDepartments = true;
        }

        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.JVAdvisor) !== -1) {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canProvideAddtionlComments = true;
        }

        if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.Sponsor) !== -1 ) {
          this.queryPermission.canViewQuery = true;
          this.queryPermission.canUpdateQuery = true;
          this.queryPermission.canProvideAddtionlComments = true;
        }
        break;
    }
  }

  exportAsPDF()//masterDtls: any
  {
    //alert(this.partnerUserMaster.length);
    //alert(this.CCSubDepartmentsMaster.length);
    //this.partnerUserMaster = masterDtls['CCSubDepartmentsMaster'];
    //this.CCSubDepartmentsMaster =  masterDtls['CCSubDepartmentsMaster'];
    this.queryService.getQueryDetails(this.queryCode).subscribe((data: any) => {
      
      if (data.output.length > 0) {
        this.adminService.getAllRegisteredPartners().subscribe((response: any) => {
          
          if (response.output.length > 0) {
            for (var i = 0; i < response.output.length; i++) {
              this.partnerUserMaster.push({ item_id: response.output[i].User_Code, item_text: response.output[i].User_Name });
            }
          }
          this.adminService.getAllSubDeptMapping().subscribe((response: any) => {
            
            if (response.output.length > 0) {
              for (var i = 0; i < response.output.length; i++) {
                this.CCSubDepartmentsMaster.push({ item_id: response.output[i].Sub_Dept_Code, item_text: response.output[i].Department_Name + ' - ' + response.output[i].Sub_Dept_Name });
              }
              this.queryDetails = data.output as QueryDetailModel[];
              if (this.currentUser.Is_Partner) {
                pdfMake.createPdf(this.getDocDefinition()).download(this.generatefilename(this.queryDetails[0].Query_Reference_Number ));
              }
              else if (!this.currentUser.Is_Partner) {
                pdfMake.createPdf(this.getDocumentDefinition()).download(this.generatefilename(this.queryDetails[0].Query_Reference_Number));
              }
            }
          });
        });
      }
    });
  }

  generatefilename(query_reference_number: string): string {  
    return query_reference_number + '-' + new Date().toLocaleDateString() + '.pdf';
  }
  //#region PDF Generation
  
  getDocDefinition(): TDocumentDefinitions {
    return {
      content: [[
        {
          text: 'Query Reference Number - ' + this.queryDetails[0].Query_Reference_Number,
          style: 'header'
        },
        {
          text: 'Requestor Name - ' + this.queryDetails[0].RequestorName,
          style: 'tableheader'
        }],
      this.getExportPDFDetails()
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        tableheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 12,
          bold: true
        },
        tab: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
          decoration: 'underline'
        },
        label: {
          fontSize: 10,
          bold: true,
          //width: 30,
          margin: [3, 3, 3, 3],
        },
        value: {
          fontSize: 10,
          //width: 70,
          //italics: true,
          margin: [3, 3, 3, 3],
        },
      }
    };
  }

  getDocumentDefinition(): TDocumentDefinitions {
    return {
      content: [[
        {
          text: 'Query Reference Number - ' + this.queryDetails[0].Query_Reference_Number,
          style: 'header'
        },
        {
          text: 'Requestor Name - ' + this.queryDetails[0].RequestorName,
          style: 'tableheader'
        }],
      this.getPDFDetails()
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        tableheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 12,
          bold: true
        },
        tab: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
          decoration: 'underline'
        },
        label: {
          fontSize: 10,
          bold: true,
          //width: 30,
          margin: [3, 3, 3, 3],
        },
        value: {
          fontSize: 10,
          //width: 70,
          //italics: true,
          margin: [3, 3, 3, 3],
        },
      }
    };
  }
  getQueryDetails(queryDetail: any) {
    return {
      table: {
        widths: ['*', '*'],
        body: [
          [{ text: 'Date of Request', style: 'label' }, { text: queryDetail.RequestDate, style: 'value' }],
          [{ text: 'Completion Date', style: 'label' }, { text: queryDetail.CompletionDate, style: 'value' }],
          [{ text: 'Subject', style: 'label' }, { text: queryDetail.Subject, style: 'value' }],
          [{ text: 'Priority Level', style: 'label' }, { text: queryDetail.PriorityLevel, style: 'value' }],
          [{ text: 'Confidential', style: 'label' }, { text: (queryDetail.Is_Confidential ? "Yes" : "No"), style: 'value' }],
          [{ text: 'CC Emails', style: 'label' }, { text: queryDetail.CCEmails, style: 'value' }],
        ]
      },
    };
  }
  getQueryRequestDetails(queryDetail: any) {
    this.selectedCCUsers = [];
    if (queryDetail.CCUsers) {
      for (var i = 0; i < queryDetail.CCUsers.length; i++) {
        this.selectedCCUsers.push(this.partnerUserMaster.filter(s => s["item_id"] == queryDetail.CCUsers[i])[0]["item_text"]);
      }
    }

    if (this.currentUser.Is_Partner) {
      return {
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: 'Block', style: 'label' }, { text: queryDetail.Block, style: 'value' }],
            [{ text: 'Company', style: 'label' }, { text: queryDetail.CompanyName, style: 'value' }],
            [{ text: 'Department', style: 'label' }, { text: queryDetail.Department, style: 'value' }],
            [{ text: 'Sub Department', style: 'label' }, { text: queryDetail.SubDepartment, style: 'value' }],
            [{ text: 'CC', style: 'label' }, { text: this.selectedCCUsers.join(', '), style: 'value' }],
            [{ text: 'Partner Comments', style: 'label' }, { text: queryDetail.Partner_Comment, style: 'value' }]
          ]
        }
      };
    }
    else {
      this.selectedCCSubDepts = [];
      if (queryDetail.CCSubDepartments) {
        for (var i = 0; i < queryDetail.CCSubDepartments.length; i++) {
          this.selectedCCSubDepts.push(this.CCSubDepartmentsMaster.filter(s => s["item_id"] == queryDetail.CCSubDepartments[i])[0]["item_text"]);
        }
      }

      return {
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: 'Block', style: 'label' }, { text: queryDetail.Block, style: 'value' }],
            [{ text: 'Company', style: 'label' }, { text: queryDetail.CompanyName, style: 'value' }],
            [{ text: 'Department', style: 'label' }, { text: queryDetail.Department, style: 'value' }],
            [{ text: 'Sub Department', style: 'label' }, { text: queryDetail.SubDepartment, style: 'value' }],
            [{ text: 'CC Sub Department', style: 'label' }, { text: this.selectedCCSubDepts.join(', '), style: 'value' }],
            [{ text: 'CC', style: 'label' }, { text: this.selectedCCUsers.join(', '), style: 'value' }],
            [{ text: 'Company Restricted', style: 'label' }, { text: (queryDetail.Company_Restricted ? "Yes" : "No"), style: 'value' }],
            [{ text: 'Partner Comments', style: 'label' }, { text: queryDetail.Partner_Comment, style: 'value' }],
            [{ text: 'Query Category', style: 'label' }, { text: queryDetail.Category, style: 'value' }],
            [{ text: 'Query Sub Category', style: 'label' }, { text: queryDetail.SubCategory, style: 'value' }],
            [{ text: 'Letter Reference Number', style: 'label' }, { text: queryDetail.LetterReference_Number, style: 'value' }],
            [{ text: 'Contract Number', style: 'label' }, { text: queryDetail.Contract_Number, style: 'value' }],
            [{ text: 'AFE Number', style: 'label' }, { text: queryDetail.AFE_Number, style: 'value' }],
            [{ text: 'Work Order Number', style: 'label' }, { text: queryDetail.Work_Order_Number, style: 'value' }],
            [{ text: 'Category Comment', style: 'label' }, { text: queryDetail.Category_Comments, style: 'value' }],
          ]
        }
      };
    }

  }
  getExportPDFDetails() {
    const exs:any[] = [];
    var count = 0;
    this.queryDetails.forEach(queryDetail => {
      count++;
      exs.push(
        [{
          columns: [
            [{
              text: 'Query Detail ' + count, background: 'yellow',
              style: 'tableheader'
            },
            this.getQueryDetails(queryDetail),
            {
              text: 'Clarification Request Details',
              style: 'tableheader'
            },
            this.getQueryRequestDetails(queryDetail),
            {
              text: 'Query Resolution Details',
              style: 'tableheader'
            },

            { text: 'Resolution Comments', style: 'tab' },
            {
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [{ text: queryDetail.Resolution_Comment, style: 'value' }]
                ]
              }
            }
            ]]
        }]
      );
    });
    return {
      table: {
        widths: ['*'],
        body: [
          ...exs
        ]
      }
    };
  }
  getPDFDetails() {
    const exs:any[] = [];
    var count = 0;
    this.queryDetails.forEach(queryDetail => {
      count++;
      exs.push(
        [{
          columns: [
            [{
              text: 'Query Detail ' + count, background: 'yellow',
              style: 'tableheader'
            },
            this.getQueryDetails(queryDetail),
            {
              text: 'Clarification Request Details',
              style: 'tableheader'
            },
            this.getQueryRequestDetails(queryDetail),
            {
              text: 'Query Resolution Details',
              style: 'tableheader'
            },
            {
              text: 'Consolidated Comments',
              style: 'tab'
            },
            {
              table: {
                headerRows: 1,
                style: 'value',
                widths: ['*', 'auto', 'auto'],
                body: [
                        [
                          { text: 'Commented By', style: 'label' }, 
                          { text: 'Comment', style: 'label' }, 
                          { text: 'Commented Date', style: 'label' }
                        ],                        
                  ...queryDetail.ConsolidatedComment.map((p:any) => ([
                    { text: p["CommentedBy"], style: 'value' },
                    { text: p["Comment"], style: 'value' },
                    { text: p["CommentedDate"], style: 'value' }])),
                ]
              }
            },
            { text: 'Resolution Comments', style: 'tab' },
            {
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [{ text: queryDetail.Resolution_Comment, style: 'value' }]
                ]
              }
            }
            ]]
        }]
      );
    });
    return {
      table: {
        widths: ['*'],
        body: [
          ...exs
        ]
      }
    };
  }
  //#endregion

}
